// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"a9f7392b","168":"388f1efe","338":"bdb3f316","544":"76b5103b","576":"44aa007b","595":"90757a7e","753":"b2660e2c","775":"64825fe5","990":"72efe63c"}[chunkId] + ".js";
};